import { Component, OnInit } from '@angular/core';
import { UserService } from './core/user/user.service';
import { AnalyticsService } from './core/analytics/analytics.service';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
    /**
     * Constructor
     */
    constructor(
        private _userService: UserService,
        private _analyticsService: AnalyticsService,
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this._userService.setTheme();
        this._analyticsService.init();
    }
}
